import {
  GridCellProps,
  GridColumn as Column,
} from '@progress/kendo-react-grid';
import {
  AdminSubHeaderMainLayout,
  CollapsibleAuditLog,
  PageSectionHeading,
} from 'Components/Display';
import { AddButton } from 'Components/Form';
import { EditDeleteCell, MainGrid } from 'Components/Grid';
import { useEnums } from 'Context';
import { Permission } from 'Models/Templates/Permission/Permission';
import { PermissionCodesV3 } from 'Models/Authorization/permissionCodesV3';
import { addEditRoute, AddEditSubRoute } from 'Navigation';
import { ROUTES } from 'Navigation/Routes';
import React from 'react';
import { ENDPOINTS } from 'Models/Templates/Routes/Routes';
import { defaultGridProps } from 'Models/GridModels';
import { SecureComponent } from 'Components/Security';
import { SecureComponentV3 } from 'Components/Security/SecureComponentV3';

export const UserManagementRoles: React.FC = () => {
  const { entityEventType } = useEnums();

  return (
    <AdminSubHeaderMainLayout title="Roles">
      <PageSectionHeading
        titleButton={
          <SecureComponent permissions={[Permission.AddRole]}>
            <AddButton url={addEditRoute(AddEditSubRoute.Role)}>
              New Role
            </AddButton>
          </SecureComponent>
        }
      >
        V2 Roles
      </PageSectionHeading>
      <MainGrid readEndpoint={ENDPOINTS.roles.read} {...defaultGridProps}>
        <Column field="name" title="Name" />
        <Column field="id" title=" " cell={ActionsCell} />
      </MainGrid>

      <SecureComponentV3 permissions={[PermissionCodesV3.Role.Panel.View]}>
        <PageSectionHeading
          titleButton={
            <SecureComponentV3
              permissions={[PermissionCodesV3.Role.Management.Create]}
            >
              <AddButton url={ROUTES.V3_ROLE}>New V3 Role</AddButton>
            </SecureComponentV3>
          }
        >
          V3 Roles
        </PageSectionHeading>
        <MainGrid
          readEndpoint={ENDPOINTS.roles.read}
          apiVersion="3.0"
          {...defaultGridProps}
        >
          <Column field="name" title="Name" />
          <Column field="code" title="Code" />
          <Column field="description" title="Description" />
          <Column
            field="id"
            title=" "
            cell={(props: GridCellProps) => (
              <EditDeleteCell
                editRoute={ROUTES.V3_ROLE}
                editPermissionsV3={[PermissionCodesV3.Role.Management.Edit]}
                deletePermissionsV3={[PermissionCodesV3.Role.Management.Delete]}
                deleteEndpoint={ENDPOINTS.roles.base}
                entityName="V3 Role"
                apiVersion="3.0"
                {...props}
              />
            )}
          />
        </MainGrid>
      </SecureComponentV3>

      <CollapsibleAuditLog
        title="Audit Log"
        entityEventType={entityEventType.Role?.value}
      />
    </AdminSubHeaderMainLayout>
  );
};

const ActionsCell: React.FC<GridCellProps> = (props: GridCellProps) => {
  return (
    <EditDeleteCell
      editRoute={addEditRoute(AddEditSubRoute.Role)}
      editPermissions={[Permission.EditRole]}
      deletePermissions={[Permission.DeleteRole]}
      deleteEndpoint={ENDPOINTS.roles.base}
      {...props}
    />
  );
};
